export const ORGANIZATIONS_URL = '/organization/v2/organizations';
